import React, { useState } from "react";
import "./settings.scss";
import { Button, Form, Input } from "antd";
import url from "../../url.json";
import headers from "../../config/headers";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { generatePassword, isStrongPassword } from "../../config/password";
import PasswordMeter from "../../components/PasswordMeter/PasswordMeter";

// Sozlamalar: hisob parolini almashtirish
function Settings({ t }) {
  const [form] = Form.useForm();
  const [error, setError] = useState();
  const [saving, setSaving] = useState(false);
  const password = Form.useWatch("password", form) || "";

  const fieldErr = (name) =>
    error?.[name] ? { validateStatus: "error", help: [].concat(error[name])[0] } : {};

  const handleGenerate = () => {
    const pwd = generatePassword();
    form.setFieldsValue({ password: pwd, password_confirmation: pwd });
    setError((e) => ({ ...e, password: undefined, password_confirmation: undefined }));
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(pwd).then(
        () => toast.success(t("pw_generated_copied")),
        () => toast.info(t("pw_generated"))
      );
    } else toast.info(t("pw_generated"));
  };

  const onFinish = (values) => {
    if (!isStrongPassword(values.password)) {
      setError({ password: [t("pw_rules_error")] });
      return;
    }
    if (values.password !== values.password_confirmation) {
      setError({ password_confirmation: [t("pw_mismatch")] });
      return;
    }
    setSaving(true);
    axios
      .post(url.url + "/legal-entity/password", values, { headers: headers() })
      .then(() => {
        toast.success(t("ln_password_changed"));
        setError();
        form.resetFields();
      })
      .catch((err) => {
        const res = err.response;
        if (!res) return toast.error(t("Something went wrong"));
        if (res.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location = "/login";
          return;
        }
        if (res.data?.errors) setError(res.data.errors);
        else toast.error(res.data?.message || res.data?.error || t("Something went wrong"));
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="pf">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Settings")}</title>
      </Helmet>

      <section className="ln-cab__page-head">
        <span className="ln-eyebrow">{t("ln_cab_group_account")}</span>
        <h1>{t("Settings")}</h1>
        <p>{t("ln_settings_text")}</p>
      </section>

      <Form form={form} className="pf-form st-form" layout="vertical" requiredMark={false} onFinish={onFinish} autoComplete="off">
        <section className="pf-card">
          <div className="pf-card__title pf-card__title--split">
            <span>
              <i className="bx bx-lock-alt" />
              {t("ln_change_password")}
            </span>
            <button type="button" className="ln-signup__gen" onClick={handleGenerate}>
              <i className="bx bx-refresh" />
              {t("pw_generate")}
            </button>
          </div>

          <div className="st-grid">
            <div className="st-fields">
              <Form.Item
                label={t("Old password")}
                name="old_password"
                rules={[{ required: true, message: t("field_required") }]}
                {...fieldErr("old_password")}
              >
                <Input.Password autoComplete="current-password" placeholder="••••••••" />
              </Form.Item>
              <div className="st-divider" />
              <Form.Item
                label={t("New password")}
                name="password"
                rules={[{ required: true, message: t("field_required") }]}
                {...fieldErr("password")}
              >
                <Input.Password autoComplete="new-password" placeholder={t("Password entry")} />
              </Form.Item>
              <Form.Item
                label={t("Password confirmation")}
                name="password_confirmation"
                rules={[{ required: true, message: t("field_required") }]}
                {...fieldErr("password_confirmation")}
              >
                <Input.Password autoComplete="new-password" placeholder={t("Password confirmation entry")} />
              </Form.Item>
            </div>
            <aside className="st-side">
              <PasswordMeter value={password} />
              <div className="st-tips">
                <i className="bx bx-shield-quarter" />
                <p>{t("ln_password_tip")}</p>
              </div>
            </aside>
          </div>
        </section>

        <div className="pf-actions">
          <span>{t("ln_password_hint")}</span>
          <Button type="primary" htmlType="submit" loading={saving}>
            <i className="bx bx-save" style={{ marginRight: 8 }} />
            {t("Save")}
          </Button>
        </div>
      </Form>
    </div>
  );
}
export default withTranslation()(Settings);
